module.exports = __webpack_public_path__ + "img/Logo_IS_2018-03-15_mbe.e3cf6b14.png";